// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4o-p2_enVOOYhen-R_QtmKcZ-4FCCAII",
  authDomain: "parikshado-251ad.firebaseapp.com",
  projectId: "parikshado-251ad",
  storageBucket: "parikshado-251ad.firebasestorage.app",
  messagingSenderId: "56060949680",
  appId: "1:56060949680:web:3ca2a5f84a7e907391b775"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

export {app, auth, db};

